import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0",
    type: "button"
  }, [
    /*#__PURE__*/_createTextVNode(" Export "),
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" })
  ])
], -1)
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " # "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " date "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " client "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " montant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " montant sans epargne "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
    }, " Actions ")
  ])
], -1)
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-paragraph" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dropdown" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "badge text-white bg-primary fs-15 dropdown-toggle",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      /*#__PURE__*/_createTextVNode(" Actions "),
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
    ]),
    /*#__PURE__*/_createElementVNode("ul", { class: "dropdown-menu" })
  ])
], -1)
const _hoisted_17 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "search-box position-relative",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Field, {
              name: "dateDebut",
              type: "date",
              value: _ctx.getCurrentDate(),
              class: "form-control shadow-none fs-md-15 text-black"
            }, null, 8, ["value"]),
            _createVNode(_component_ErrorMessage, {
              name: "dateVente",
              class: "text-danger"
            })
          ])
        ])
      ], 32),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (vente, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(vente.id), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.format_date(vente.dateVente)), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(vente.client.prenoms+ ' ' + vente.client.nom), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(vente.montant), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString((vente.montant)? vente.montantSansEpargne : '-'), 1),
                _hoisted_16
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}